import dayjs from 'dayjs';

(function () {
    'use strict';
    angular
        .module('ib-basket-module')
        .factory('ibBasketTransformer', ibBasketTransformer);

    ibBasketTransformer.$inject = ['localStorageService', 'CurrencyService', 'NewMainHeaderConstants', '$filter', '$rootScope'];
    function ibBasketTransformer (localStorageService, CurrencyService, NewMainHeaderConstants, $filter, $rootScope) {

        return {
            transformTripsCart: transformTripsCart,
            transformTripsFromOrder: transformTripsFromOrder,
            transformTripsCartFromDispo: transformTripsCartFromDispo,
            deleteTripsCartFromDispo: deleteTripsCartFromDispo,
            checkFreeSeats: checkFreeSeats
        };

        function checkFreeSeats (seats) {
            let paymentPassenger = [], freePassenger = [], totalAmountPaymentPassenger = 0, totalAmountFreePassenger = 0;
            const seatsTemp = Object.assign({}, seats), header = localStorageService.get('headerModel').headerModel;
            Object.assign(seatsTemp, seats);
            angular.forEach(seatsTemp.segments, (segment) => {
                angular.forEach(segment.seats, (segmentSeat) => {
                    paymentPassenger = [],
                    freePassenger = [];
                    totalAmountPaymentPassenger = 0;
                    angular.forEach(segmentSeat.passengers, (passenger) => {
                        if(passenger.amount === 0) {
                            freePassenger.push(passenger);
                        }else {
                            paymentPassenger.push(passenger);
                        }
                    });
                    angular.forEach(freePassenger,  (dataFreePassenger) => {
                        dataFreePassenger.amountFormatted = CurrencyService.formatPrice(header.shoppingBasket.currency, dataFreePassenger.amount, true);
                        totalAmountFreePassenger = dataFreePassenger.amountFormatted;
                    });
                    angular.forEach(paymentPassenger,  (dataPaymentPassenger) => {
                        dataPaymentPassenger.amountFormatted = CurrencyService.formatPrice(header.shoppingBasket.currency, dataPaymentPassenger.amount, true);
                        totalAmountPaymentPassenger += totalAmountPaymentPassenger + dataPaymentPassenger.amount;
                    });
                    segmentSeat.freePassenger = freePassenger;
                    segmentSeat.totalAmountFreePassenger = CurrencyService.formatPrice(header.shoppingBasket.currency, totalAmountFreePassenger, true);
                    segmentSeat.paymentPassenger = paymentPassenger;
                    segmentSeat.totalAmountPaymentPassenger = CurrencyService.formatPrice(header.shoppingBasket.currency, totalAmountPaymentPassenger, true);
                });
            });
            return seatsTemp;
        }
        /**
         * Delete Trips and Update Basket in Availability
         *
         **/
        function deleteTripsCartFromDispo () {
            const header = localStorageService.get('headerModel').headerModel,
                tripsInfo = {
                    trips : [],
                    total : {}
                };
            tripsInfo.total.totalPrice = 0;
            tripsInfo.total.formatted =
                  CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
            return tripsInfo;
        }


        /**
         * Transform Data for Basket in Availability
         * @param {*} offerSelected
         * @param {*} model
         **/
        function transformTripsCartFromDispo (offerSelected, model) {
            let capitalizeDate, discountsAppliedBasket = false, segment = {}, passenger = {}, passengers = [], segments = [], segmentSlice = {},
                header = localStorageService.get('headerModel').headerModel, tax,scales = false, offerItemsTemp,
                tripsInfo = {
                    trips : [],
                    total : {}
                };

            angular.forEach(model.availabilityData.originDestinations, (slice) => {
                segmentSlice.origin = angular.copy(slice.originCity);
                segmentSlice.destination = angular.copy(slice.destinationCity);

                segmentSlice.segments =[];

                angular.forEach(model.selectedSlices, (slice) => {
                    if(slice.info.departureDateTime && slice.destination === segmentSlice.destination.code ) {
                        segment.date = dayjs(slice.info.departureDateTime).locale($rootScope.appLang).format('dddd DD MMM YYYY / HH:mm');
                        capitalizeDate = segment.date[0].toUpperCase() + segment.date.slice(1);
                        segmentSlice.date = capitalizeDate;
                    }
                });
                segments.push(angular.copy(segmentSlice));
            });

            if(offerSelected.discountsApplied && offerSelected.discountsApplied.discounts && offerSelected.discountsApplied.discounts.length > 0 && offerSelected.discountsApplied.originalOfferItems && offerSelected.discountsApplied.originalOfferItems.length > 0) {
                generatePassengerModel(offerSelected.discountsApplied.originalOfferItems, passengers);
                discountsAppliedBasket = true;
            }else{
                generatePassengerModel(offerSelected.offerItems, passengers);
            }

            if(offerSelected.price && offerSelected.price.ticketingFee) {
                tripsInfo.ticketingFee = offerSelected.price.ticketingFee;
                tripsInfo.ticketingFeeFormatted = CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.ticketingFee, true);
                tripsInfo.total.totalPrice = discountsAppliedBasket ? offerSelected.discountsApplied.originalPrice.total - tripsInfo.ticketingFee :  offerSelected.price.total - tripsInfo.ticketingFee;
                tripsInfo.total.formatted =
              CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
            } else {
                tripsInfo.total.totalPrice = discountsAppliedBasket ? offerSelected.discountsApplied.originalPrice.total :  offerSelected.price.total;
                tripsInfo.total.formatted =
                CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
            }
            tripsInfo.total.original = discountsAppliedBasket ? offerSelected.discountsApplied.originalPrice.total :  offerSelected.price.total;
            tripsInfo.trips.push({
                scales : scales,
                segments:angular.copy(segments),
                passengers: angular.copy(passengers)
            });
            return tripsInfo;
        }


        /**
          Generate Passenger Model
          * @param {*} passengerData
          * @param {*} passengers
        **/
        function generatePassengerModel (passengerData, passengers) {

            angular.forEach( passengerData , (offerItem)=> {
                switch (offerItem.passengerIds[0].substring(0,offerItem.passengerIds[0].length-3)) {
                        case NewMainHeaderConstants.PASSENGER_TYPE.SENIOR:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.SENIOR, offerItem)));
                            break;
                        case NewMainHeaderConstants.PASSENGER_TYPE.ADULT:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.ADULT, offerItem)));
                            break;
                        case NewMainHeaderConstants.PASSENGER_TYPE.YOUTH:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.YOUTH, offerItem)));
                            break;
                        case NewMainHeaderConstants.PASSENGER_TYPE.YOUNG_ADULT:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.TEENAGER, offerItem)));
                            break;
                        case NewMainHeaderConstants.PASSENGER_TYPE.CHILD:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.CHILD, offerItem)));
                            break;
                        case NewMainHeaderConstants.PASSENGER_TYPE.INFANT:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.INFANT, offerItem)));
                            break;
                        default:
                            passengers.push(angular.copy(createPassenger(NewMainHeaderConstants.PASSENGER_TYPE.ADULT, offerItem)));
                            break;
                }
            });
        }

        /**
          Return a Passenger object
          * @param {*} passengerType
          * @param {*} offerItem
        **/

        function createPassenger (passengerType, offerItem) {
            const header = localStorageService.get('headerModel').headerModel;
            const passenger = {};
            passenger.quantity = offerItem.passengerIds.length;
            passenger.type = passengerType;
            passenger.description = passenger.quantity > 1 ? $filter('translate')('SOME_'+passengerType) : $filter('translate')(passengerType);
            passenger.perPassengerPrice = CurrencyService.formatPrice(header.shoppingBasket.currency, (offerItem.price.fare * passenger.quantity ), true);
            passenger.taxes = CurrencyService.formatPrice(header.shoppingBasket.currency, (offerItem.price.tax * passenger.quantity ), true);
            return passenger;
        }



        function transformTripsCart (fareData, infoAvios) {
            var capitalizeDate, segment = {},discountsAppliedBasket = false, passenger = {}, passengers = [], segments = [], segmentSlice = {},
                header = localStorageService.get('headerModel').headerModel, tax,scales = false, offerItemsTemp,
                fareData = localStorageService.get('fareData'), currency = {},
                tripsInfo = {
                    trips : [],
                    total : {}
                };

            if(fareData && fareData.contextMetadata && fareData.contextMetadata.currencies[0]) {
                currency = CurrencyService.getCurrencyObject(fareData.contextMetadata.currencies[0]);
            } else {
                currency = header.shoppingBasket.currency;
            }

            angular.forEach( fareData.offers , (offer)=> {
                if(offer.discountsApplied && offer.discountsApplied.discounts && offer.discountsApplied.discounts.length > 0) {
                    discountsAppliedBasket = true;
                }
                if(offer.price && offer.price.ticketingFee) {
                    tripsInfo.ticketingFee = offer.price.ticketingFee;
                    tripsInfo.ticketingFeeFormatted = CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.ticketingFee, true);
                    tripsInfo.total.totalPrice = discountsAppliedBasket ? offer.discountsApplied.originalPrice.total - tripsInfo.ticketingFee : offer.price.total - tripsInfo.ticketingFee;
                    tripsInfo.total.formatted =
                      CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
                } else {
                    tripsInfo.total.totalPrice = discountsAppliedBasket ? offer.discountsApplied.originalPrice.total : offer.price.total;
                    tripsInfo.total.formatted =
                        CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
                }
                tripsInfo.total.original = discountsAppliedBasket ? offer.discountsApplied.originalPrice.total : offer.price.total;
                angular.forEach(offer.slices, (slice) => {
                    segmentSlice.origin = angular.copy(slice.segments[0].departure.city);
                    segmentSlice.destination = angular.copy(slice.segments[slice.segments.length-1].arrival.city);
                    if(slice.departureDateTime) {
                        segmentSlice.date = dayjs(slice.departureDateTime).locale($rootScope.appLang).format('dddd DD MMM YYYY / HH:mm');
                        capitalizeDate = segmentSlice.date[0].toUpperCase() + segmentSlice.date.slice(1);
                        segmentSlice.date = capitalizeDate;
                    }

                    segmentSlice.segments =[];
                    angular.forEach(slice.segments, (segmentInfo) => {
                        segment.origin = segmentInfo.departure.city;
                        segment.destination = segmentInfo.arrival.city;
                        if(segmentInfo.departureDateTime) {
                            segment.date = dayjs(segmentInfo.departureDateTime).locale($rootScope.appLang).format('dddd DD MMM YYYY / HH:mm');
                            capitalizeDate = segmentSlice.date[0].toUpperCase() + segmentSlice.date.slice(1);
                            segmentSlice.date = capitalizeDate;
                        }
                        segmentSlice.segments.push(angular.copy(segment));
                    });
                    segments.push(angular.copy(segmentSlice));
                });
                if(offer.redemptionOptions || offer.promotion && infoAvios && infoAvios.totalPrice && infoAvios.totalPrice.price) {
                    scales=true;
                    if (!angular.equals({}, infoAvios)) {
                        passenger.parsedAviosFare = CurrencyService.formatAvios('.',tripsInfo.total.totalAvios = infoAvios.totalPrice.price.totalAvios ?
                            infoAvios.totalPrice.price.totalAvios : infoAvios.totalPrice.price.totalPoints);
                        tripsInfo.total.totalPrice = infoAvios.totalPrice.tax;
                        tripsInfo.total.formatted =
                            CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.SENIOR]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.SENIOR);
                        }
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.ADULT]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.ADULT);
                        }
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.CHILD]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.CHILD);
                        }
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.INFANT]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.INFANT);
                        }
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.YOUTH]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.YOUTH);
                        }
                        if (infoAvios.summaryInfo.passengers.generalData[NewMainHeaderConstants.PASSENGER_TYPE.YOUNG_ADULT]) {
                            createPassengerAvios(NewMainHeaderConstants.PASSENGER_TYPE.TEENAGER);
                        }
                    }
                } else {
                    if(offer.discountsApplied) {
                        offerItemsTemp = offer.discountsApplied.originalOfferItems;
                    } else {
                        offerItemsTemp = offer.offerItems;
                    }
                    generatePassengerModel(offerItemsTemp, passengers);
                }
                tripsInfo.trips.push({
                    scales : scales,
                    segments:angular.copy(segments),
                    passengers: angular.copy(passengers)
                });
            });
            return tripsInfo;

            function createPassengerAvios (passengerType) {
                passenger.quantity= infoAvios.summaryInfo.passengers.generalData[passengerType][0].number;
                passenger.type = passengerType;
                passenger.description = passenger.quantity > 1 ? $filter('translate')('SOME_'+passengerType) : $filter('translate')(passengerType);
                tax = infoAvios.summaryInfo.passengers.generalData[passengerType][0].totalTax;
                passenger.perPassengerPrice = CurrencyService.formatPrice(currency,
                    (infoAvios.summaryInfo.passengers.generalData[passengerType][0].fare) * passenger.quantity, true);
                passenger.taxes = CurrencyService.formatPrice(currency, tax , true);
                passenger.parsedAviosFare = CurrencyService.formatAvios('.',infoAvios.summaryInfo.passengers.generalData[passengerType][0].aviosFare * passenger.quantity);
                tripsInfo.total.totalPrice = tripsInfo.total.totalPrice + (infoAvios.summaryInfo.passengers.generalData[passengerType][0].fare * passenger.quantity);
                tripsInfo.total.formatted = CurrencyService.formatPrice(currency, tripsInfo.total.totalPrice, true);

                // GTL-1095 Recalculate breakdown passengers
                let breakdownPassengers = localStorageService.get('breakdownPassengers'), pricePerPax = {};

                if (breakdownPassengers && breakdownPassengers.selectedRedeption) {
                    if (breakdownPassengers.selectedRedeption.pricePerPax) {
                        pricePerPax = breakdownPassengers.selectedRedeption.pricePerPax;
                    } else if (breakdownPassengers.selectedRedeption.discountedPrice && breakdownPassengers.selectedRedeption.discountedPrice.pricePerPax) {
                        pricePerPax = breakdownPassengers.selectedRedeption.discountedPrice.pricePerPax;
                    } else if (breakdownPassengers.selectedRedeption.basePrice && breakdownPassengers.selectedRedeption.basePrice.pricePerPax) {
                        pricePerPax = breakdownPassengers.selectedRedeption.basePrice.pricePerPax;
                    }

                    angular.forEach(pricePerPax, (price) => {
                        if (passengerType == price.paxType) {
                            passenger.perPassengerPrice = CurrencyService.formatPrice(currency, (price.cash.fare * passenger.quantity), true);
                            passenger.parsedAviosFare = CurrencyService.formatAvios(currency.groupingSeparator, (price.points.fare * passenger.quantity));
                        }
                    });

                } else {
                    passenger.perPassengerPrice = CurrencyService.formatPrice(currency,
                        (infoAvios.summaryInfo.passengers.generalData[passengerType][0].fare) * passenger.quantity, true);
                    passenger.parsedAviosFare = CurrencyService.formatAvios(currency.groupingSeparator, infoAvios.summaryInfo.passengers.generalData[passengerType][0].aviosFare * passenger.quantity);
                }

                passengers.push(angular.copy(passenger));
            }

            function createPassenger (passengerType, offerItem) {
                passenger.quantity = offerItem.passengerIds.length;
                passenger.type = passengerType;
                passenger.description = passenger.quantity > 1 ? $filter('translate')('SOME_'+passengerType) : $filter('translate')(passengerType);
                passenger.perPassengerPrice = CurrencyService.formatPrice(currency, (offerItem.price.fare * passenger.quantity ), true);
                passenger.taxes = CurrencyService.formatPrice(currency, (offerItem.price.tax * passenger.quantity ), true);
                passengers.push(angular.copy(passenger));

            }
        }

        function transformTripsFromOrder (bookingInfo) {
            let discountsAppliedBasket = false, capitalizeDate, segment = {}, segments = [], segmentSlice = {},
                header = localStorageService.get('headerModel').headerModel,
                oldTripsInfo = header.shoppingBasket.trips,
                tripsInfo = {
                    trips : [],
                    total : oldTripsInfo.total
                };
            if(bookingInfo.order.discountsApplied && bookingInfo.order.discountsApplied.discounts && bookingInfo.order.discountsApplied.discounts.length > 0 && bookingInfo.order.discountsApplied.originalOrderItems && bookingInfo.order.discountsApplied.originalOrderItems.length > 0) {
                discountsAppliedBasket = true;
            }

            if(bookingInfo.order.price.ticketingFee) {
                tripsInfo.total.totalPrice = discountsAppliedBasket ? bookingInfo.order.discountsApplied.originalPrice.total - bookingInfo.order.price.ticketingFee : bookingInfo.order.price.total - bookingInfo.order.price.ticketingFee;
            }else{
                tripsInfo.total.totalPrice = discountsAppliedBasket ? bookingInfo.order.discountsApplied.originalPrice.total : bookingInfo.order.price.total;
            }

            tripsInfo.total.original = tripsInfo.total.totalPrice;
            tripsInfo.total.formatted =
            CurrencyService.formatPrice(header.shoppingBasket.currency, tripsInfo.total.totalPrice, true);


            angular.forEach(oldTripsInfo.trips, (oldTrip) => {
                segments = [];
                angular.forEach(bookingInfo.order.slices, (slice) => {
                    segmentSlice.origin = angular.copy(slice.segments[0].departure.city);
                    segmentSlice.destination = angular.copy(slice.segments[slice.segments.length-1].arrival.city);
                    if(slice.departureDateTime) {
                        segmentSlice.date = dayjs(slice.departureDateTime).locale($rootScope.appLang).format('dddd DD MMM YYYY / HH:mm');
                        capitalizeDate = segmentSlice.date[0].toUpperCase() + segmentSlice.date.slice(1);
                        segmentSlice.date = capitalizeDate;
                    }

                    segmentSlice.segments =[];
                    angular.forEach(slice.segments, (segmentInfo) => {
                        segment.origin = segmentInfo.departure.city;
                        segment.destination = segmentInfo.arrival.city;
                        if(segmentInfo.departureDateTime) {
                            segment.date = dayjs(segmentInfo.departureDateTime).locale($rootScope.appLang).format('dddd DD MMM YYYY / HH:mm');
                            capitalizeDate = segmentSlice.date[0].toUpperCase() + segmentSlice.date.slice(1);
                            segmentSlice.date = capitalizeDate;
                        }
                        segmentSlice.segments.push(angular.copy(segment));
                    });
                    segments.push(angular.copy(segmentSlice));
                });

                //Update fare info for passengers types
                angular.forEach(oldTrip.passengers, (passenger) => {
                    if(discountsAppliedBasket) {
                        updatePassengerType(passenger, bookingInfo.order.discountsApplied.originalOrderItems[0].passengerPrices, bookingInfo.passengers);
                    }else if(bookingInfo.order.orderItems && bookingInfo.order.orderItems.length > 0 && bookingInfo.order.orderItems[0].passengerPrices) {
                        updatePassengerType(passenger, bookingInfo.order.orderItems[0].passengerPrices, bookingInfo.passengers);
                    }

                });

                tripsInfo.trips.push({
                    scales : oldTrip.scales,
                    segments:angular.copy(segments),
                    passengers: angular.copy(oldTrip.passengers)
                });
            });
            return tripsInfo;

            function updatePassengerType (passenger, passengerPrices, bookingInfoPassengers) {
                let typeAux = '';
                let taxes = 0;
                let price = 0;
                let passengersInfo = [];
                passenger.quantity = 0;
                passenger.namesList = [];

                angular.forEach(passengerPrices, (individualPrice)=> {
                    typeAux = individualPrice.passengerId.split('_')[0];
                    if(typeAux === passenger.type) {
                        taxes += individualPrice.price.tax;
                        price += individualPrice.price.fare;
                        passenger.quantity += 1;
                    }
                });
                passenger.perPassengerPrice = CurrencyService.formatPrice(header.shoppingBasket.currency, ( price ), true);
                passenger.taxes = CurrencyService.formatPrice(header.shoppingBasket.currency, (taxes), true);
                passengersInfo = bookingInfoPassengers?.filter((pass) => pass.passengerType.includes(passenger.type));
                passengersInfo?.forEach((passengerInfo) => {
                    if (passengerInfo?.externalPersonalInfo) passenger.namesList.push(Object.values(passengerInfo?.externalPersonalInfo).join(' ').trim());
                });
            }
        }
    }
})();
